"use strict";

exports.__esModule = true;
exports.default = pluck;
var _map = _interopRequireDefault(require("./map.js"));
var _property = _interopRequireDefault(require("./property.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Convenience version of a common use case of `_.map`: fetching a property.
function pluck(obj, key) {
  return (0, _map.default)(obj, (0, _property.default)(key));
}